export function SectionHeader({ title, loading }: { title: string; loading: boolean }) {
  return (
    <div className="flex items-center justify-between gap-3 border-b border-border px-4 py-3">
      <h2 className="font-semibold">{title}</h2>
      {loading ? <span className="text-sm text-muted-foreground">Đang tải…</span> : null}
    </div>
  );
}
